import React, { useState } from "react";
import { C } from "../theme";
import { fmt, fmtD, Tag, Kpi, Btn, Inp, Sel } from "../shared";

export const CotisationsPage = ({ cotisations, setCotisations, residents, immId }) => {
  const [modal, setModal]       = useState(false);
  const [filter, setFilter]     = useState("tous");
  const [tab, setTab]           = useState("liste");
  const [relanceSent, setRelanceSent] = useState({});
  const [form, setForm]         = useState({residentId:"",montant:"",echeance:"",type:"Charges courantes"});
  const all      = cotisations.filter(c => c.immId === immId);
  const filtered = filter === "tous" ? all : all.filter(c => c.statut === filter);
  const immRes   = residents.filter(r => r.immId === immId);
  const enRetard = all.filter(c => ["retard","impayé"].includes(c.statut));

  const payer = id => setCotisations(p => p.map(c =>
    c.id === id ? {...c, statut:"payé", paiement:new Date().toISOString().slice(0,10)} : c
  ));
  const save = () => {
    const r = immRes.find(x => x.id === Number(form.residentId));
    if (!r) return;
    setCotisations(p => [...p, {id:Date.now(), residentId:r.id, immId,
      resident:`${r.nom} ${r.prenom}`, montant:Number(form.montant),
      echeance:form.echeance, paiement:null, statut:"en attente", type:form.type}]);
    setModal(false);
  };
  const total = all.reduce((a,c) => a + c.montant, 0);
  const paye  = all.filter(c => c.statut === "payé").reduce((a,c) => a + c.montant, 0);

  const sendRelance = (cotId, type) => {
    setRelanceSent(prev => ({...prev, [`${cotId}-${type}`]: true}));
  };

  const RELANCE_TYPES = [
    {k:"j7",  label:"J-7",  desc:"Rappel avant échéance",  color:C.blue,   bg:C.blueL},
    {k:"j3",  label:"J-3",  desc:"Rappel urgent",           color:C.gold,   bg:"#fffbeb"},
    {k:"j1",  label:"J+1",  desc:"Mise en demeure retard",  color:C.red,    bg:"#fff1f1"},
    {k:"sms", label:"SMS",  desc:"Message court",           color:C.purple, bg:"#f5f3ff"},
  ];

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Cotisations</h2>
          <p style={{color:C.muted,fontSize:13}}>Suivi des paiements & relances automatisées</p>
        </div>
        <Btn onClick={() => setModal(true)}>+ Nouvel appel</Btn>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
        <Kpi icon="💵" label="Total appelé"  value={fmt(total)}      color={C.blue}  delay={0} />
        <Kpi icon="✅" label="Encaissé"      value={fmt(paye)}       sub={`${Math.round((paye/(total||1))*100)}%`} color={C.green} delay={60} />
        <Kpi icon="⏳" label="Restant dû"    value={fmt(total-paye)} color={C.red}   delay={120} />
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:4,marginBottom:18,background:C.card,padding:5,borderRadius:12,width:"fit-content",boxShadow:"0 2px 10px rgba(11,19,51,.05)"}}>
        {[{k:"liste",i:"📋",l:"Liste"},{k:"relances",i:"📧",l:"Relances"}].map(t => (
          <button key={t.k} className="btn" onClick={() => setTab(t.k)}
            style={{padding:"7px 16px",borderRadius:9,fontSize:13,fontWeight:600,
              background:tab===t.k?C.teal:"transparent",color:tab===t.k?"#fff":C.muted,
              display:"inline-flex",alignItems:"center",gap:6}}>
            {t.i} {t.l}
            {t.k==="relances" && enRetard.length>0 &&
              <span style={{background:C.red,color:"#fff",borderRadius:"50%",width:18,height:18,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700}}>{enRetard.length}</span>}
          </button>
        ))}
      </div>

      {/* ── LISTE ── */}
      {tab === "liste" && (
        <div className="fi">
          <div style={{display:"flex",gap:7,marginBottom:14,flexWrap:"wrap"}}>
            {["tous","payé","impayé","retard","en attente"].map(f => (
              <button key={f} className="btn" onClick={() => setFilter(f)}
                style={{padding:"5px 13px",borderRadius:20,fontSize:12,fontWeight:600,
                  background:filter===f?C.teal:"#fff",color:filter===f?"#fff":C.muted}}>
                {f.charAt(0).toUpperCase()+f.slice(1)} ({f==="tous"?all.length:all.filter(c=>c.statut===f).length})
              </button>
            ))}
          </div>
          <div style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
            <table>
              <thead><tr><th>Copropriétaire</th><th>Type</th><th>Montant</th><th>Échéance</th><th>Paiement</th><th>Statut</th><th>Action</th></tr></thead>
              <tbody>
                {filtered.map(c => (
                  <tr key={c.id}>
                    <td style={{fontWeight:600}}>{c.resident}</td>
                    <td style={{color:C.muted}}>{c.type}</td>
                    <td style={{fontWeight:700}}>{fmt(c.montant)}</td>
                    <td>{fmtD(c.echeance)}</td>
                    <td style={{color:C.muted}}>{fmtD(c.paiement)}</td>
                    <td><Tag s={c.statut} /></td>
                    <td style={{display:"flex",gap:6}}>
                      {c.statut !== "payé" && (
                        <button onClick={() => payer(c.id)}
                          style={{padding:"5px 11px",background:`${C.green}22`,color:C.green,border:"none",borderRadius:8,cursor:"pointer",fontWeight:600,fontSize:12}}>
                          ✓ Payé
                        </button>
                      )}
                      {["retard","impayé"].includes(c.statut) && (
                        <button onClick={() => { setTab("relances"); }}
                          style={{padding:"5px 11px",background:`${C.gold}22`,color:C.gold,border:"none",borderRadius:8,cursor:"pointer",fontWeight:600,fontSize:12}}>
                          📧 Relancer
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── RELANCES ── */}
      {tab === "relances" && (
        <div className="fi">
          {/* Configuration des relances automatiques */}
          <div style={{background:`linear-gradient(135deg,${C.navy},#1a2b7a)`,borderRadius:16,padding:22,marginBottom:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div>
                <h4 style={{color:"#fff",fontSize:15,fontWeight:700,marginBottom:4}}>⚙️ Relances automatisées</h4>
                <p style={{color:"rgba(255,255,255,.45)",fontSize:12}}>Emails envoyés automatiquement selon le calendrier d'échéance</p>
              </div>
              <div style={{background:"rgba(14,201,164,.2)",borderRadius:10,padding:"6px 14px",display:"flex",alignItems:"center",gap:6}}>
                <div style={{width:8,height:8,borderRadius:"50%",background:C.teal}} />
                <span style={{color:C.teal,fontSize:12,fontWeight:700}}>Actif</span>
              </div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
              {RELANCE_TYPES.map(rt => (
                <div key={rt.k} style={{background:"rgba(255,255,255,.08)",borderRadius:11,padding:14,textAlign:"center"}}>
                  <p style={{fontSize:22,fontWeight:800,color:rt.color,fontFamily:"Syne",marginBottom:3}}>{rt.label}</p>
                  <p style={{fontSize:11,color:"rgba(255,255,255,.45)"}}>{rt.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Liste des retardataires */}
          <div style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
            <div style={{padding:"17px 22px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <h4 style={{fontSize:15,fontWeight:700,color:C.text}}>⚠️ {enRetard.length} paiement(s) en attente de relance</h4>
              <button className="btn" onClick={() => {
                enRetard.forEach(c => RELANCE_TYPES.forEach(rt => sendRelance(c.id, rt.k)));
              }} style={{padding:"7px 16px",background:`linear-gradient(135deg,${C.teal},#0ba882)`,color:"#fff",borderRadius:10,fontWeight:600,fontSize:13}}>
                📧 Relancer tout le monde
              </button>
            </div>

            {enRetard.length === 0 ? (
              <div style={{padding:48,textAlign:"center"}}>
                <p style={{fontSize:36,marginBottom:10}}>🎉</p>
                <p style={{fontSize:15,fontWeight:700,color:C.text}}>Aucun retardataire !</p>
                <p style={{fontSize:13,color:C.muted}}>Tous les copropriétaires sont à jour.</p>
              </div>
            ) : enRetard.map(c => {
              const sentKeys = RELANCE_TYPES.filter(rt => relanceSent[`${c.id}-${rt.k}`]);
              return (
                <div key={c.id} style={{padding:"16px 22px",borderBottom:`1px solid ${C.border}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                    <div style={{display:"flex",alignItems:"center",gap:12}}>
                      <div style={{width:40,height:40,borderRadius:11,background:"#fee2e2",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>⚠️</div>
                      <div>
                        <p style={{fontWeight:700,color:C.text,fontSize:14}}>{c.resident}</p>
                        <p style={{fontSize:12,color:C.muted}}>{c.type} · Échéance {fmtD(c.echeance)} · <strong style={{color:C.red}}>{fmt(c.montant)}</strong></p>
                      </div>
                    </div>
                    <Tag s={c.statut} />
                  </div>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    {RELANCE_TYPES.map(rt => {
                      const done = !!relanceSent[`${c.id}-${rt.k}`];
                      return (
                        <button key={rt.k} className="btn" onClick={() => sendRelance(c.id, rt.k)}
                          style={{padding:"6px 13px",borderRadius:9,fontSize:12,fontWeight:600,
                            background:done?"#d1fae5":rt.bg,
                            color:done?"#065f46":rt.color,
                            border:`1.5px solid ${done?"#6ee7b7":rt.color}33`,
                            opacity:done?.85:1}}>
                          {done ? `✓ ${rt.label} envoyé` : `📧 ${rt.label}`}
                        </button>
                      );
                    })}
                  </div>
                  {sentKeys.length > 0 && (
                    <p style={{fontSize:11,color:C.muted,marginTop:8}}>
                      ✅ {sentKeys.length} relance(s) envoyée(s) · Dernière : {new Date().toLocaleTimeString("fr-FR", {hour:"2-digit",minute:"2-digit"})}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:20}}>Nouvel appel de fonds</h3>
            <div style={{marginBottom:14}}>
              <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase"}}>Copropriétaire</label>
              <select value={form.residentId} onChange={e => setForm({...form,residentId:e.target.value})}
                style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,fontFamily:"DM Sans",background:"#fff"}}>
                <option value="">— Sélectionner —</option>
                {immRes.map(r => <option key={r.id} value={r.id}>{r.prenom} {r.nom} ({r.apt})</option>)}
              </select>
            </div>
            <Inp label="Montant (MAD)" type="number" value={form.montant} onChange={v => setForm({...form,montant:v})} />
            <Inp label="Date d'échéance" type="date" value={form.echeance} onChange={v => setForm({...form,echeance:v})} />
            <Sel label="Type" value={form.type} onChange={v => setForm({...form,type:v})} options={["Charges courantes","Appel de fonds","Travaux","Provision"]} />
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Créer</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — FACTURATION
══════════════════════════════════════ */
